# Safari Autofill Fix
# ===================
#
# Specifically, this fixes issues with the Safari autofill when select fields
# are completed (such as a province dropdown) from an address card.

angular.module('wbDirectives').directive 'input', ->
  priority: 1000
  restrict: 'E'
  link: ($scope, $el, $attrs) ->
    select = null
    $el.on 'change', ->
      select ||= $el.closest('form').find('select')
      return unless select?.length > 1
      setTimeout (-> select.trigger('change')), 100
      true

angular.module('wbDirectives').directive 'form', ->
  priority: 1000
  restrict: 'E'
  link: ($scope, $el, $attrs) ->
    select = null
    $el.on 'submit', ->
      select ||= $el.find('select')
      return unless select?.length > 1
      $el.find('select').trigger('change')
      true
